import React from 'react';
import { Box, Container, Grid, Typography, Paper } from '@mui/material';
import {
  Verified as AccreditedIcon, EmojiEvents as ExcellenceIcon, Groups as FacultyIcon, LocalHospital as ClinicalIcon,
  MenuBook as LibraryIcon, Hotel as HostelIcon,
} from '@mui/icons-material';
import { Reveal, HOME_COLORS, sectionLabelSx } from './common';

const FEATURES = [
  { icon: AccreditedIcon, title: 'Recognized & Affiliated', text: 'Programs affiliated to the state nursing council with recognized statutory approvals.' },
  { icon: ClinicalIcon, title: 'Hands-on Clinical Training', text: 'Structured hospital postings and a skills log book that tracks every procedure signed off.' },
  { icon: FacultyIcon, title: 'Experienced Faculty', text: 'A dedicated, qualified teaching faculty focused on individual student growth.' },
  { icon: ExcellenceIcon, title: 'Academic Excellence', text: 'Consistent results driven by disciplined attendance, exams and continuous evaluation.' },
  { icon: LibraryIcon, title: 'Well-Stocked Library', text: 'A dedicated nursing library with textbooks, journals and reference material.' },
  { icon: HostelIcon, title: 'Safe Campus Hostel', text: 'Comfortable, secure hostel facilities for outstation students with round-the-clock care.' },
];

const GRADIENTS = [
  [HOME_COLORS.dark, HOME_COLORS.teal],
  [HOME_COLORS.sky, HOME_COLORS.skyLight],
  [HOME_COLORS.mid, HOME_COLORS.sky],
];

export default function FeaturesSection() {
  return (
    <Box id="features" sx={{ py: { xs: 8, md: 12 }, bgcolor: HOME_COLORS.skyPale, scrollMarginTop: '80px' }}>
      <Container maxWidth="lg">
        <Reveal>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography sx={sectionLabelSx}>Why Choose Us</Typography>
            <Typography variant="h3" sx={{ fontWeight: 800, color: HOME_COLORS.dark, fontSize: { xs: '2rem', md: '2.6rem' } }}>
              Everything you need to succeed
            </Typography>
            <Typography sx={{ color: '#657875', maxWidth: 620, mx: 'auto', mt: 1.5 }}>
              A complete academic and campus experience designed around every nursing student's journey.
            </Typography>
          </Box>
        </Reveal>

        <Grid container spacing={3}>
          {FEATURES.map((f, idx) => {
            const [c1, c2] = GRADIENTS[idx % GRADIENTS.length];
            return (
              <Grid item xs={12} sm={6} md={4} key={f.title}>
                <Reveal delay={(idx % 3) * 90}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3.5, borderRadius: 4, height: '100%', bgcolor: '#fff', border: '1px solid #dbeefc',
                      transition: 'transform 0.35s ease, box-shadow 0.35s ease',
                      '&:hover': { transform: 'translateY(-8px)', boxShadow: '0 20px 40px rgba(14,165,233,0.16)' },
                      '&:hover .feature-icon': { transform: 'rotate(-8deg) scale(1.08)' },
                    }}
                  >
                    <Box
                      className="feature-icon"
                      sx={{
                        width: 58, height: 58, borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: `linear-gradient(135deg, ${c1}, ${c2})`, mb: 2.5,
                        transition: 'transform 0.35s ease',
                      }}
                    >
                      <f.icon sx={{ color: '#fff', fontSize: 28 }} />
                    </Box>
                    <Typography sx={{ fontWeight: 800, color: HOME_COLORS.dark, mb: 1, fontSize: '1.05rem' }}>{f.title}</Typography>
                    <Typography variant="body2" sx={{ color: '#657875' }}>{f.text}</Typography>
                  </Paper>
                </Reveal>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}
